'use client';

import { useState } from 'react';

import type { TattooImage } from '@/types/tattooImage.types';

import ImageLightbox from '../ImageLightbox/ImageLightbox';

type TattooGalleryProps = {
  images: Array<TattooImage>;
};

const TattooGallery = ({ images }: TattooGalleryProps) => {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  return (
    <>
      <div className="columns-2 gap-4 sm:columns-3 md:columns-4">
        {images.map((image, index) => (
          <div
            key={image.id || index}
            className="group relative mb-4 cursor-pointer break-inside-avoid overflow-hidden rounded-lg"
            onClick={() => setLightboxIndex(index)}
          >
            <img
              src={image.image_url}
              alt={`Tatouage ${index + 1}`}
              width={300}
              height={400}
              loading="lazy"
              className="w-full object-cover transition-all group-hover:scale-105"
            />
          </div>
        ))}
      </div>

      <ImageLightbox
        images={images}
        initialIndex={lightboxIndex ?? 0}
        isOpen={lightboxIndex !== null}
        onClose={() => setLightboxIndex(null)}
      />
    </>
  );
};

export default TattooGallery;
